import { Component, computed, input, model, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Calendar_Fill, DropdownArrow } from '@spaces-ui/meadow/icons/svgs';

import { MdwDatePickerHeader } from '../date-picker-header/date-picker-header';

@Component({
  selector: 'mdw-date-picker',
  templateUrl: './date-picker.html',
  styleUrls: ['./date-picker.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDatepickerModule, MdwButton, FormsModule, MatInputModule, MdwIcon],
})
export class MdwDatePicker {
  readonly header = MdwDatePickerHeader;

  public value = model<Date>();
  public triggerType = input<'button' | 'input'>('button');
  public filterType = input<'future' | 'past' | 'none'>('none');
  public icon = input<string>(Calendar_Fill);
  public dateFormatOptions = input<Intl.DateTimeFormatOptions>({
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  public icons = { DropdownArrow };

  public dateFilter = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }

    const filterStrategy = this.filterType();
    if (!filterStrategy || filterStrategy === 'none') {
      return true;
    }

    // Get the start of today
    const todayStart = new Date(new Date().setHours(0, 0, 0, 0));

    if (filterStrategy === 'future') {
      // Return true if the date is today or earlier
      return d < new Date(todayStart.getTime() + 24 * 60 * 60 * 1000);
    }

    // Return true if the date is today or later
    return d >= todayStart;
  };

  public displayValue = computed(() => {
    const value = this.value();
    if (!value) {
      return 'Choose a date';
    }

    const formattedValue = new Intl.DateTimeFormat('en-US', this.dateFormatOptions()).format(value);

    return formattedValue;
  });

  public isPlaceholder = computed(() => {
    return !this.value();
  });
}
